import React from 'react';

const useUnmountEffect = (callback: () => void) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies(callback): [chris hunter] - callback not needed in deps as it is only to be executed on unmount
  React.useEffect(() => callback, []);
};

export default useUnmountEffect;
